import { render, staticRenderFns } from "./PopularTopicsList.vue?vue&type=template&id=35dd5c54&scoped=true&"
import script from "./PopularTopicsList.vue?vue&type=script&lang=js&"
export * from "./PopularTopicsList.vue?vue&type=script&lang=js&"
import style0 from "./PopularTopicsList.vue?vue&type=style&index=0&id=35dd5c54&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd5c54",
  null
  
)

export default component.exports